import Theme from './component/Theme';

export default Theme;
